module.exports = __webpack_public_path__ + "13b4a6a32c9b07eac43cca1a5515a4f7.png";